import styles from "./LCatalogLanding.module.css";

/**
 * LCatalogLanding - catalog layout typu landing page.
 *
 * **Charakterystyka:**
 *   - Layout `hideChrome: true` -> PublicLayoutView NIE renderuje HDefault
 *     (header), FDefault (footer), top message. Sama tresc landing'u widoczna.
 *   - `<main>` ma klase `.mainFullWidth` (zdjete `max-width` + `padding`).
 *   - Szerokoscia steruje per-strefa kazdy wewnetrzny div (zob. CSS):
 *     - `.above` / `.below` - full bleed (hero/CTA na cala szerokosc)
 *     - `.content` - centered + padding (jak normalna strona, max-width 1500px)
 *
 * **Struktura (gora -> dol):**
 *   - aboveCatalog (window area - okna nad trescia katalogu, np. hero banner)
 *   - catalogContent (BLOCKED, tresc katalogu z catalog management - np.
 *     CDescriptivePage z akapitami)
 *   - belowCatalog (window area - okna pod trescia, np. CTA / kontakt)
 *
 * **Use cases:**
 *   - Landing page kampanii marketingowej (hero + tresc + CTA)
 *   - Podstrona produktu z dedykowanym layoutem (bez nawigacji)
 *   - Side projekt na osobnej domenie z minimalnym chrome
 *
 * **Roadmap (TODO):** mechanizm "full bleed paragraph" - mozliwosc oznaczenia
 * wybranych akapitow zeby rozszerzaly sie do 100% viewport'u mimo ze rodzic
 * `.content` jest constrained do 1500px. Wzorzec CSS Grid named tracks na
 * `.content` + klasa `.fullBleed` na akapicie (zob. komentarz w CSS).
 */
export function LCatalogLanding({
  aboveCatalog,
  catalogContent,
  belowCatalog,
}: LCatalogLandingProps) {
  return (
    <div className={styles.root}>
      {aboveCatalog ? <div className={styles.above}>{aboveCatalog}</div> : null}
      <div className={styles.content}>{catalogContent}</div>
      {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
    </div>
  );
}

export type LCatalogLandingProps = {
  aboveCatalog: React.ReactNode;
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
};
